import { Component, Input } from '@angular/core';
import { ModalDirective } from '@hs/ui-core-layout';

import { DashboardNote, emptyNote } from '../../../models/dashboard-note';
import { DashboardNoteComponent } from '../dashboard-note/dashboard-note.component';
import { ViewNoteButtonComponent } from '../view-note-button/view-note-button.component';

@Component({
    selector: 'ddv-view-dashboard-note',
    templateUrl: './view-dashboard-note-dropdown.component.html',
    styleUrls: ['./view-dashboard-note-dropdown.component.scss'],
    imports: [
        DashboardNoteComponent,
        ModalDirective,
        ViewNoteButtonComponent,
    ],
})
export class ViewDashboardNoteDropdownComponent {
    @Input() note: DashboardNote = emptyNote();

    protected showModal = false;
}
